import React, { useEffect, useState } from "react";
import { Table, Button, Spinner, Modal, Alert } from "react-bootstrap";
import SecureFileLink from "../meeting/SecureFileLink";
import authConfig from "../../authConfig";
import {
    format,
    subYears
} from 'date-fns';

export default function FormSubmissionsList({ formId = null, allowPdfDownload = true }) {
    const [submissions, setSubmissions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadingError, setLoadingError] = useState(null);
    const [selectedSubmissionJson, setSelectedSubmissionJson] = useState(null);

    useEffect(() => {
        let cancelled = false;
        const load = async () => {
            setLoading(true);
            setLoadingError(null);
            try {
                let url = authConfig.api?.urls?.getMemberFormSubmissionsForMember;

                if (!url) {
                    setLoadingError("No fetchUrl or formId provided for FormSubmissionsList.");
                    setSubmissions([]);
                    return;
                }

                const res = await fetch(url, { credentials: "include" });
                if (!res.ok) throw new Error(`Failed to load submissions: ${res.status} ${res.statusText}`);
                const data = await res.json();
                if (cancelled) return;
                // Normalize items to use id / Id and common fields
                const mapped = (data || []).map((s) => ({
                    id: s.id ?? s.Id ?? s.submissionId ?? null,
                    memberFormName: s.memberFormName,
                    memberName: s.memberName ?? s.MemberName ?? s.Submitter ?? "",
                    submittedOn: s.submittedOn ?? s.SubmittedOn ?? s.createdAt ?? "",
                    submissionDataJson: s.submissionDataJson ?? s.SubmissionDataJson ?? s.data ?? "{}",
                }));
                setSubmissions(mapped);
            } catch (ex) {
                console.error(ex);
                if (!cancelled) setLoadingError(ex?.message || "Error loading submissions");
            } finally {
                if (!cancelled) setLoading(false);
            }
        };

        load();
        return () => {
            cancelled = true;
        };
    }, []);

    const openSubmissionJson = (json) => {
        try {
            const parsed = typeof json === "string" ? JSON.parse(json) : json;
            setSelectedSubmissionJson(JSON.stringify(parsed, null, 2));
        } catch {
            setSelectedSubmissionJson(json || "");
        }
    };

    if (loading) return <div className="text-center"><Spinner animation="border" /></div>;
    if (loadingError) return <Alert variant="danger">{loadingError}</Alert>;
    if (!submissions || submissions.length === 0) return <div>No submissions found.</div>;

    return (
        <>
            <Table striped bordered hover size="sm">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Form</th>
                        <th>Submitted On</th>
                        <th className="text-end">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {submissions.map((s, i) => (
                        <tr key={s.id ?? i}>
                            <td>{i + 1}</td>
                            <td>{s.memberFormName}</td>
                            <td>{ format(new Date(s.submittedOn), "dd/MM/yy HH:mm" )}</td>
                            <td className="text-end">
                                {/*<Button size="sm" variant="outline-primary" className="me-1"*/}
                                {/*    onClick={() => openSubmissionJson(s.submissionDataJson)}>*/}
                                {/*    View JSON*/}
                                {/*</Button>*/}

                                {allowPdfDownload && s.id && (
                                    <SecureFileLink
                                        type="button"
                                        url={authConfig.api.urls.getMemberFormSubmissionPdfForMember + "/" + s.id + "/submission.pdf?dt=" + (new Date()).getTime()}
                                        filename={"submission.pdf"}>
                                        View PDF
                                    </SecureFileLink>
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            <Modal show={selectedSubmissionJson !== null} onHide={() => setSelectedSubmissionJson(null)} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Submission JSON</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                        {selectedSubmissionJson || ""}
                    </pre>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setSelectedSubmissionJson(null)}>Close</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}